import { apiSchematicMapBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

export class EditionAPI {
    constructor() {
        this.baseUrl = new URL("schematicmap/edition/", apiSchematicMapBaseURL);
    }

    getNetworks() {
        const url = new URL("network", this.baseUrl);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}